<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66683 9.99935C2.29864 9.99935 2.00016 9.70087 2.00016 9.33268C2.00016 8.96449 2.29864 8.66602 2.66683 8.66602H6.66683C7.03502 8.66602 7.3335 8.96449 7.3335 9.33268V13.3327C7.3335 13.7009 7.03502 13.9994 6.66683 13.9994C6.29864 13.9994 6.00016 13.7009 6.00016 13.3327V10.9422L2.47157 14.4708C2.21122 14.7311 1.78911 14.7311 1.52876 14.4708C1.26841 14.2104 1.26841 13.7883 1.52876 13.5279L5.05735 9.99935H2.66683Z"
    />
    <path
      d="M13.3334 6.00065C13.7016 6.00065 14.0001 6.29913 14.0001 6.66732C14.0001 7.03551 13.7016 7.33398 13.3334 7.33398L9.33341 7.33398C8.96522 7.33398 8.66675 7.03551 8.66675 6.66732L8.66675 2.66732C8.66675 2.29913 8.96523 2.00065 9.33342 2.00065C9.7016 2.00065 10.0001 2.29913 10.0001 2.66732L10.0001 5.05784L13.5287 1.52925C13.789 1.2689 14.2111 1.2689 14.4715 1.52925C14.7318 1.78959 14.7318 2.21171 14.4715 2.47205L10.9429 6.00065L13.3334 6.00065Z"
    />
  </svg>
</template>
